import { ZIndex } from '@opallabs/gem'
import { pluralize } from '@opallabs/lambda'
import { Tooltip } from '@opallabs/lapidary'
import * as styles from '../styles'
import { AddMomentToBoardModalProps } from '../types'

type ValidationMessageProps = Pick<
  AddMomentToBoardModalProps,
  'relatedResources'
> & {
  invalidMomentCount: number
  momentCount: number
}

export const ValidationMessage: React.FC<ValidationMessageProps> = ({
  invalidMomentCount,
  relatedResources,
  momentCount,
}) => {
  if (!invalidMomentCount) return null

  if (momentCount === 1) {
    return (
      <div css={styles.singleMessageContainer} className={styles.messageClass}>
        This block has a type that is not paired with a moment and cannot be
        added to a board.
      </div>
    )
  }

  const invalidResources = relatedResources?.filter(
    ({ momentId }) => momentId === null
  )
  if (!invalidResources?.length) return null

  return (
    <div css={styles.bulkMessageContainer} className={styles.messageClass}>
      <Tooltip
        content={invalidResources.map(({ title }) => title).join(', ')}
        zIndex={ZIndex.Shroud.Tooltip}
      >
        <span>
          {invalidResources.length}{' '}
          {pluralize('block', invalidResources.length)}
        </span>
      </Tooltip>
      &nbsp;selected {invalidResources.length > 1 ? 'have' : 'has'} a type that
      is not paired with a moment and cannot be added to a board.
    </div>
  )
}
